import { useOrganization } from '@/contexts/OrganizationContext';
import type { OrgProfile } from '@/types';

const CORPORATE_FAMILY: OrgProfile[] = ['company', 'building', 'cowork'];

/**
 * Perfil de la organización (migración 150) + helpers de gating.
 * Ver docs/plans/2026-08-30-modular-monolith-reorg.md
 */
export function useOrgProfile() {
  const { organization } = useOrganization();
  const profile: OrgProfile = organization?.type ?? 'company';

  return {
    profile,
    isProfile: (...p: OrgProfile[]) => p.includes(profile),
    isProfileNot: (...p: OrgProfile[]) => !p.includes(profile),
    isCowork: profile === 'cowork',
    isBuilding: profile === 'building',
    isCorporateFamily: CORPORATE_FAMILY.includes(profile),
  };
}

export default useOrgProfile;
